// routes
import { PATH } from '../../../routes/paths';
// components
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

const navConfig = [
  // Overview
  // ----------------------------------------------------------------------
  {
    items: [
      {
        permissions: [],
        title: 'layout.menus.overview',
        path: PATH.overview,
        icon: <Iconify icon={'ic:baseline-dashboard'} />,
      },
    ],
  },

  // Invoices
  // ----------------------------------------------------------------------
  {
    subheader: 'layout.menus.invoices.root',
    items: [
      {
        permissions: ['web.billing.management.view', 'web.billing.management.create', 'web.billing.management.return'],
        title: 'layout.menus.invoices.sale',
        path: PATH.invoice.sale.root,
        icon: <Iconify icon={'ic:baseline-receipt'} />,
      },
      {
        permissions: ['web.billing.management.view', 'web.billing.management.create', 'web.billing.management.return'],
        title: 'layout.menus.invoices.purchase',
        path: PATH.invoice.purchase.root,
        icon: <Iconify icon={'ic:baseline-description'} />,
      },
      {
        permissions: ['web.billing.management.view', 'web.billing.management.create', 'web.billing.management.return'],
        title: 'layout.menus.invoices.note',
        path: PATH.invoice.note.root,
        icon: <Iconify icon={'ic:baseline-note-add'} />,
      },
      {
        permissions: ['web.billing.management.view', 'web.billing.management.create', 'web.billing.management.return'],
        title: 'layout.menus.invoices.prepayment',
        path: PATH.invoice.prepayment.root,
        icon: <Iconify icon={'ic:baseline-payments'} />,
      },
      {
        permissions: ['web.expense.management.view', 'web.expense.management.create', 'web.expense.management.return'],
        title: 'layout.menus.invoices.expense',
        path: PATH.invoice.expense.root,
        condition: (user) => user?.business?.featuresactive?.includes('feature.expense'),
        icon: <Iconify icon={'ic:baseline-request-quote'} />,
      },
      {
        permissions: ['web.billing.management.view', 'web.billing.management.create', 'web.billing.management.return'],
        title: 'layout.menus.invoices.payment',
        path: PATH.invoice.payment.root,
        icon: <Iconify icon={'ic:baseline-payment'} />,
      },
    ],
  },

  // Stock
  // ----------------------------------------------------------------------
  {
    subheader: 'layout.menus.stock.root',
    items: [
      {
        permissions: [
          'web.stock.transfer.management.view',
          'web.stock.transfer.management.create',
          'web.stock.transfer.management.edit',
          'web.stock.transfer.management.delete',
        ],
        title: 'layout.menus.stock.transfer',
        path: PATH.stock.transfer.root,
        condition: (user) => user?.business?.featuresactive?.includes('feature.stock'),
        icon: <Iconify icon={'ic:baseline-sync-alt'} />,
      },
      {
        permissions: [
          'web.stock.adjustment.management.view',
          'web.stock.adjustment.management.create',
          'web.stock.adjustment.management.edit',
          'web.stock.adjustment.management.delete',
        ],
        title: 'layout.menus.stock.adjustment',
        path: PATH.stock.adjustment.root,
        condition: (user) => user?.business?.featuresactive?.includes('feature.stock'),
        icon: <Iconify icon={'ic:baseline-tune'} />,
      },
      {
        permissions: ['web.reports.stock'],
        title: 'layout.menus.stock.transaction',
        path: PATH.stock.transaction.root,
        condition: (user) => user?.business?.featuresactive?.includes('feature.stock'),
        icon: <Iconify icon={'ic:baseline-view-timeline'} />,
      },
    ],
  },

  // Accounts
  // ----------------------------------------------------------------------
  {
    subheader: 'layout.menus.accounting.root',
    items: [
      {
        permissions: [
          'web.account.management.view',
          'web.account.management.create',
          'web.account.management.edit',
          'web.account.management.delete',
        ],
        title: 'layout.menus.accounting.journalEntry',
        path: PATH.accounting.journalEntry.root,
        icon: <Iconify icon={'ic:baseline-library-books'} />,
      },
      {
        permissions: ['web.reports.account'],
        title: 'layout.menus.accounting.trialBalance',
        path: PATH.accounting.trialBalance.root,
        icon: <Iconify icon={'ic:baseline-difference'} />,
      },
      {
        permissions: ['web.reports.account'],
        title: 'layout.menus.accounting.profitLoss',
        path: PATH.accounting.profitLoss.root,
        icon: <Iconify icon={'ic:round-trending-up'} />,
      },
      {
        permissions: ['web.reports.account'],
        title: 'layout.menus.accounting.profitLossDetailed',
        path: PATH.accounting.profitLoss.detailed,
        icon: <Iconify icon={'ic:baseline-auto-graph'} />,
      },
      {
        permissions: ['web.reports.account'],
        title: 'layout.menus.accounting.balanceSheet',
        path: PATH.accounting.balanceSheet.root,
        icon: <Iconify icon={'ic:baseline-account-balance'} />,
      },
      // {
      //   permissions: ['web.reports.account'],
      //   title: 'layout.menus.accounting.balanceSheetDetailed',
      //   path: PATH.accounting.balanceSheet.detailed,
      //   condition: (user) => user?.business?.featuresactive?.includes('feature.account'),
      //   icon: <Iconify icon={'ic:round-account-balance-wallet'} />,
      // },
      {
        permissions: ['web.reports.tax'],
        title: 'layout.menus.report.tax',
        path: PATH.report.tax,
        condition: (user) => !user?.business?.tax_exemption,
        icon: <Iconify icon={'ic:baseline-article'} />,
      },
      {
        permissions: [
          'web.account.management.view',
          'web.account.management.create',
          'web.account.management.edit',
          'web.account.management.delete',
        ],
        title: 'layout.menus.accounting.account',
        path: PATH.accounting.account.root,
        icon: <Iconify icon={'ic:baseline-account-tree'} />,
      },
      {
        permissions: [
          'web.account.management.view',
          'web.account.management.create',
          'web.account.management.edit',
          'web.account.management.delete',
        ],
        title: 'layout.menus.accounting.accountSettings',
        path: PATH.accounting.accountSettings.root,
        icon: <Iconify icon={'ic:baseline-settings'} />,
      },
    ],
  },

  // Master
  // ----------------------------------------------------------------------
  {
    subheader: 'layout.menus.master.root',
    items: [
      {
        permissions: [
          'web.partner.management.view',
          'web.partner.management.create',
          'web.partner.management.edit',
          'web.partner.management.delete',
        ],
        title: 'layout.menus.master.customer',
        path: PATH.customer.root,
        icon: <Iconify icon={'ic:baseline-groups'} />,
      },
      {
        permissions: [
          'web.partner.management.view',
          'web.partner.management.create',
          'web.partner.management.edit',
          'web.partner.management.delete',
        ],
        title: 'layout.menus.master.supplier',
        path: PATH.supplier.root,
        icon: <Iconify icon={'ic:baseline-group'} />,
      },
      {
        permissions: [
          'web.product.management.view',
          'web.product.management.create',
          'web.product.management.edit',
          'web.product.management.delete',
        ],
        title: 'layout.menus.master.product',
        path: PATH.product.root,
        icon: <Iconify icon={'ic:baseline-inventory'} />,
      },
      {
        permissions: [
          'web.category.product.management.view',
          'web.category.product.management.create',
          'web.category.product.management.edit',
          'web.category.product.management.delete',
        ],
        title: 'layout.menus.master.categoryProduct',
        path: PATH.categoryProduct.root,
        icon: <Iconify icon={'ic:baseline-category'} />,
      },
    ],
  },

  // Reports
  // ----------------------------------------------------------------------
  {
    subheader: 'layout.menus.report.root',
    items: [
      {
        permissions: ['web.reports.sale'],
        title: 'layout.menus.report.sale',
        path: PATH.report.sale,
        icon: <Iconify icon={'ic:baseline-analytics'} />,
      },
      {
        permissions: ['web.reports.purchase'],
        title: 'layout.menus.report.purchase',
        path: PATH.report.purchase,
        icon: <Iconify icon={'ic:baseline-assessment'} />,
      },
      {
        permissions: ['web.reports.profitLoss'],
        title: 'layout.menus.report.profitLoss',
        path: PATH.report.profitLoss,
        icon: <Iconify icon={'ic:baseline-assignment'} />,
      },
      {
        permissions: ['web.reports.expense'],
        title: 'layout.menus.report.expense',
        path: PATH.report.expense,
        condition: (user) => user?.business?.featuresactive?.includes('feature.expense'),
        icon: <Iconify icon={'ic:baseline-explicit'} />,
      },
      {
        permissions: ['web.reports.stock'],
        title: 'layout.menus.report.stock',
        path: PATH.report.stock,
        condition: (user) => user?.business?.featuresactive?.includes('feature.stock'),
        icon: <Iconify icon={'ic:baseline-view-timeline'} />,
      },
      {
        permissions: ['web.reports.dispatch'],
        title: 'layout.menus.report.dispatch',
        path: PATH.report.dispatch,
        icon: <Iconify icon={'ic:baseline-assignment'} />,
      },
    ],
  },

  // Project
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'layout.menus.project.root',
  //   items: [
  //     {
  //       permissions: [
  //         'web.project.project.management.view',
  //         'web.project.project.management.create',
  //         'web.project.project.management.edit',
  //         'web.project.project.management.delete'
  //       ],
  //       title: 'layout.menus.project.board',
  //       path: PATH.project.root,
  //       condition: (user) => user?.business?.featuresactive?.includes('feature.project'),
  //       icon: <Iconify icon={'ic:outline-developer-board'} />
  //     }
  //   ]
  // },

  // HR
  // ----------------------------------------------------------------------
  {
    subheader: 'layout.menus.hr.root',
    items: [
      {
        permissions: [
          'web.hr.management.view',
          'web.hr.management.create',
          'web.hr.management.edit',
          'web.hr.management.delete',
        ],
        condition: (user) => user?.business?.featuresactive?.includes('feature.hr'),
        title: 'layout.menus.hr.dashboard',
        path: PATH.hr.dashboard,
        icon: <Iconify icon={'ic:round-dashboard'} />,
      },
      {
        permissions: [
          'web.hr.management.view',
          'web.hr.management.create',
          'web.hr.management.edit',
          'web.hr.management.delete',
        ],
        condition: (user) => user?.business?.featuresactive?.includes('feature.hr'),
        title: 'layout.menus.hr.holiday',
        path: PATH.hr.holiday.root,
        icon: <Iconify icon={'ic:baseline-celebration'} />,
      },
      {
        permissions: [
          'web.hr.management.view',
          'web.hr.management.create',
          'web.hr.management.edit',
          'web.hr.management.delete',
        ],
        condition: (user) => user?.business?.featuresactive?.includes('feature.hr'),
        title: 'layout.menus.hr.department',
        path: PATH.hr.department.root,
        icon: <Iconify icon={'ic:baseline-account-tree'} />,
      },
      {
        permissions: [
          'web.hr.management.view',
          'web.hr.management.create',
          'web.hr.management.edit',
          'web.hr.management.delete',
        ],
        condition: (user) => user?.business?.featuresactive?.includes('feature.hr'),
        title: 'layout.menus.hr.employee',
        path: PATH.hr.employee.root,
        icon: <Iconify icon={'ic:baseline-badge'} />,
      },
      {
        permissions: [
          'web.hr.management.view',
          'web.hr.management.create',
          'web.hr.management.edit',
          'web.hr.management.delete',
        ],
        condition: (user) => user?.business?.featuresactive?.includes('feature.hr'),
        title: 'layout.menus.hr.vacation',
        path: PATH.hr.vacation.root,
        icon: <Iconify icon={'ic:baseline-beach-access'} />,
      },
      {
        permissions: [
          'web.hr.management.view',
          'web.hr.management.create',
          'web.hr.management.edit',
          'web.hr.management.delete',
        ],
        condition: (user) => user?.business?.featuresactive?.includes('feature.hr'),
        title: 'layout.menus.hr.vacationType',
        path: PATH.hr.vacationType.root,
        icon: <Iconify icon={'ic:baseline-category'} />,
      },
      {
        permissions: [
          'web.hr.management.view',
          'web.hr.management.create',
          'web.hr.management.edit',
          'web.hr.management.delete',
        ],
        condition: (user) => user?.business?.featuresactive?.includes('feature.hr'),
        title: 'layout.menus.hr.vacationPolicy',
        path: PATH.hr.vacationPolicy.root,
        icon: <Iconify icon={'ic:baseline-policy'} />,
      },
      {
        permissions: [
          'web.hr.management.view',
          'web.hr.management.create',
          'web.hr.management.edit',
          'web.hr.management.delete',
        ],
        condition: (user) => user?.business?.featuresactive?.includes('feature.hr'),
        title: 'layout.menus.hr.payroll',
        path: PATH.hr.payroll.root,
        icon: <Iconify icon={'ic:baseline-payments'} />,
      },
      {
        permissions: [
          'web.hr.management.view',
          'web.hr.management.create',
          'web.hr.management.edit',
          'web.hr.management.delete',
        ],
        condition: (user) => user?.business?.featuresactive?.includes('feature.hr'),
        title: 'layout.menus.hr.attendance',
        path: PATH.hr.attendance.root,
        icon: <Iconify icon={'ic:baseline-fingerprint'} />,
      },
    ],
  },

  // Employee Portal
  // ----------------------------------------------------------------------
  {
    subheader: 'layout.menus.portal.root',
    employeeOnly: true,
    items: [
      {
        permissions: [],
        title: 'layout.menus.portal.overview',
        path: PATH.portal.overview,
        icon: <Iconify icon={'ic:round-dashboard'} />,
      },
      {
        permissions: [],
        title: 'layout.menus.portal.profile',
        path: PATH.portal.profile,
        icon: <Iconify icon={'ic:baseline-person'} />,
      },
      {
        permissions: [],
        title: 'layout.menus.portal.vacations',
        path: PATH.portal.vacations,
        icon: <Iconify icon={'ic:baseline-beach-access'} />,
      },
      {
        permissions: [],
        title: 'layout.menus.portal.attendance',
        path: PATH.portal.attendance,
        icon: <Iconify icon={'ic:baseline-fingerprint'} />,
      },
    ],
  },

  // Management
  // ----------------------------------------------------------------------
  {
    subheader: 'layout.menus.management.root',
    items: [
      {
        permissions: [],
        title: 'layout.menus.management.settings',
        path: PATH.management.settings.root,
        icon: <Iconify icon={'ic:baseline-settings'} />,
      },
      {
        permissions: ['web.user.management.view', 'web.user.management.edit', 'web.user.management.create'],
        title: 'layout.menus.management.member',
        path: PATH.management.member.root,
        icon: <Iconify icon={'ic:baseline-manage-accounts'} />,
      },
      {
        permissions: ['web.branch.management.view', 'web.branch.management.edit', 'web.branch.management.create'],
        title: (user) =>
          user?.business?.featuresactive?.includes('feature.stock')
            ? 'layout.menus.management.branch.stock'
            : 'layout.menus.management.branch.branch',
        path: PATH.management.branch.root,
        condition: (user) =>
          user?.business?.featuresactive?.includes('feature.pos') ||
          user?.business?.featuresactive?.includes('feature.stock'),
        icon: <Iconify icon={'ic:baseline-business'} />,
      },
      {
        permissions: ['web.team.management.view', 'web.team.management.edit', 'web.team.management.create'],
        title: 'layout.menus.management.team',
        path: PATH.management.team.root,
        condition: (user) => user?.business?.featuresactive?.includes('feature.team'),
        icon: <Iconify icon={'ic:baseline-group-work'} />,
      },
      {
        permissions: [
          'web.payment.method.management.view',
          'web.payment.method.management.create',
          'web.payment.method.management.edit',
          'web.payment.method.management.delete',
        ],
        title: 'layout.menus.management.paymentMethod',
        path: PATH.management.paymentMethod.root,
        icon: <Iconify icon={'ic:baseline-payments'} />,
      },
    ],
  },
];

export default navConfig;
